import { INVITE_RULES } from "./rules";
import { SITE } from "./site";

export const HOME_CONTENT = {
  metadata: {
    title: "首页",
  },
  hero: {
    kicker: "FROM THE FORESTS OF LAOS",
    title: "源自老挝山林的原生态中药材品牌",
    emphasis: "老挝山林",
    description:
      "老挝地处热带季风气候区,山林资源丰富,许多植物原料仍保留自然生长状态。从源头选择到检测标准,每一个环节都决定了你的最终体验。",
    primaryAction: { label: "了解品牌故事", href: "/story" },
    secondaryAction: { label: "进入产品商城", href: "/tea" },
    memberAction: { label: "成为会员 / 获取邀请码", href: "/member/login" },
    memberPrefix: "已是会员?",
    memberEntry: { label: "会员入口", href: "/member" },
    origin: { code: SITE.coords, name: SITE.region },
    watermark: "本草考察志",
    imageLabel: "素材位:老挝山林航拍 · 9:16",
    scrollLabel: "↓ SCROLL",
  },
  origin: {
    eyebrow: { code: "CHAPTER 01 · ORIGIN", name: "壹 · 品牌初心" },
    title: "我们没有把产品简单理解为一件商品",
    titleLines: ["我们没有把产品", "简单理解为一件商品"],
    paragraphs: [
      "品牌团队在长期走访中发现,老挝当地不仅有适合日常饮用与收藏的古树茶,也有多种具有传统养生价值的草本与中药材资源。",
      "我们把它视为从产区到用户生活的一条完整链路:源头选择、原料筛选、加工控制、检测标准、包装呈现、用户服务。",
    ],
    action: { label: "查看源头故事 →", href: "/story" },
  },
  terroir: {
    eyebrow: { code: "CHAPTER 02 · TERROIR", name: "贰 · 老挝原生态产区" },
    title: "山林、水源、气候与土壤,共同沉淀原料品质",
    titleLines: ["山林、水源、气候与土壤", "共同沉淀原料品质"],
    ecology: [
      { title: "山林生态", desc: "远离过度工业化环境,保留自然生长基础。" },
      { title: "天然水源", desc: "山间水源滋养植物生长,形成自然生态循环。" },
      { title: "适宜气候", desc: "雨热条件与山地环境共同影响原料品质。" },
      { title: "自然土壤", desc: "土壤、植被与时间共同沉淀原料风味与特性。" },
    ],
    processLabel: {
      code: "QUALITY PROCESS · 全程可溯",
      name: "品质保障 · 六道工序",
    },
    process: [
      { number: "01", title: "产地走访", desc: "了解原料生长环境,建立源头认知。" },
      { number: "02", title: "人工采收", desc: "根据不同原料特性进行采摘和收集。" },
      { number: "03", title: "原料初选", desc: "剔除杂质、残次和不符合标准的原料。" },
      { number: "04", title: "晒制分选", desc: "依原料特性晒制、分级,保留自然风味。" },
      { number: "05", title: "批次检测", desc: "按批次留样送检,检测结果可查。" },
      { number: "06", title: "仓储包装", desc: "标准化仓储与批号包装,溯源直达。" },
    ],
    action: { label: "查看原料溯源", href: "/story#terroir" },
  },
  productLines: {
    eyebrow: { code: "THREE PRODUCT LINES", name: "叁 · 三条产品线" },
    title: "从一杯茶,到一套东方养生体系",
    titleLines: ["从一杯茶,到一套", "东方养生体系"],
    items: [
      {
        line: "tea",
        badge: "老挝·沙耶武里",
        title: "古树茶",
        desc: "600+ 年古树，春季采摘，日光晒制。",
        action: { label: "进入古树茶板块", href: "/tea" },
        imageLabel: "茶山素材",
      },
      {
        line: "hirudin",
        badge: "专业健康管理",
        title: "水蛭素",
        desc: "围绕中老年、久坐、应酬和关注循环健康的人群需求,提供更专业的产品选择。",
        action: { label: "进入水蛭素板块", href: "/hirudin" },
        imageLabel: "产品素材",
      },
      {
        line: "herbal",
        badge: "口袋本草糖",
        title: "汣悦解",
        desc: "葛根高良姜浓缩压片糖果，小巧便携，随身分享。",
        action: { label: "进入汣悦解板块", href: "/jiuyuejie" },
        imageLabel: "汣悦解金色包装",
      },
    ],
  },
  tea: {
    eyebrow: { code: "ANCIENT TREE TEA", name: "古树茶 · 精选" },
    title: "树龄与产区,先喝得明白",
    imageLabels: {
      "gushu-sancha": "古树晒青散茶包装图",
    },
    points: "RMB 实付每 ¥1 得 1 积分",
    buyLabel: "购买",
    action: { label: "领取茶样,先试后买 →", href: "/tea" },
  },
  hirudin: {
    eyebrow: { code: "HIRUDIN LINE", name: "水蛭素 · 主力产品" },
    title: "给家人的循环健康,选专业的一支",
    titleLines: ["给家人的循环健康,", "选专业的一支"],
    productName: "GICN水蛭素复合胶囊",
    productNote: "30粒",
    sheetNumber: "SPEC SHEET NO. HRD-001",
    specs: [
      { label: "成分", value: "黄芪、枸杞、党参、纳豆激酶、水蛭素" },
      { label: "规格", value: "30粒" },
      {
        label: "适用场景",
        value: "中老年、久坐、应酬频繁、关注循环健康的人群的日常健康管理",
      },
    ],
    chips: ["批次检测", "溯源可查", "邀请码享折扣"],
    price: "399",
    points: "RMB 实付每 ¥1 得 1 积分",
    buyAction: { label: "立即购买", href: "/product/hirudin-399" },
    consultAction: { label: "咨询客服" },
    consultSheet: {
      title: "咨询客服",
      body: "客服渠道接入中，请先通过页面底部联系方式咨询",
      closeLabel: "知道了",
    },
    legal: "本品不能代替药物。具体功能以产品说明书及相关资质为准。",
  },
  membership: {
    eyebrow: { code: "MEMBERSHIP", name: "肆 · 会员权益" },
    title: "买过一次,就有一本自己的档案",
    titleLines: ["买过一次,就有一本", "自己的档案"],
    benefits: [
      { title: "购物积分", desc: "RMB 实付每 ¥1 得 1 积分。" },
      { title: "积分兑换", desc: "积分可兑换茶叶、产品券、运费券与礼品。" },
      { title: "专属优惠", desc: "会员价、优惠券与限时活动提前知道。" },
      { title: "邀请返利", desc: "分享专属邀请码,好友下单你得返利。" },
    ],
    registerAction: { label: "注册会员", href: "/member/login" },
    rulesAction: { label: "查看分销规则" },
    rulesSheet: {
      title: "分销规则",
      ...INVITE_RULES,
    },
  },
  footer: {
    archiveLabel: "FIELD ARCHIVE",
    links: [
      { label: "品牌故事", href: "/story" },
      { label: "古树茶", href: "/tea" },
      { label: "水蛭素", href: "/hirudin" },
      { label: "汣悦解", href: "/jiuyuejie" },
      { label: "会员中心", href: "/member" },
    ],
    legal: "本品不能代替药物。具体功能以产品说明书及相关资质为准。",
  },
} as const;
